import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {CurrencyPipe, DatePipe, PercentPipe} from "@angular/common";
import {PipelinesService} from "../../../../pipelines.service";

@Component({
  selector: 'pipelines-panel-project-dates',
  imports: [
    CurrencyPipe,
    PercentPipe,
    DatePipe
  ],
  templateUrl: './pipelines-panel-project-dates.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pipelines-panel-project-dates.component.scss', '../../pipelines-table.component.scss']
})
export class PipelinesPanelProjectDatesComponent implements OnInit{
  constructor(private _pipelinesService: PipelinesService) {
  }
  @Input() detail:any;
  public expanded: boolean = false;
  public rows: { label: string; key: string }[][] = [];
  public dateDetail:any;
  public milestoneDetail:any;

  private displayFields: { label: string; key: string }[] = [
    { label: 'Applied', key: 'Applied' },
    { label: 'LOI Closing Date', key: 'LOI Closing Date' },
    { label: 'Awarded', key: 'Awarded'},
    { label: 'LOI Maturity', key: 'LOI Maturity' },
    { label: 'Prospected/Modeled', key: 'Prospected/Modeled'},
    { label: 'Request for Proposal Deadline', key: 'Request for Proposal Deadline'},
    { label: 'Placement Committee Reviewed', key: 'Placement Committee Reviewed'},
    { label: 'Full Closed', key: 'Full Closed'},
    { label: 'Placement Committee Approved', key: 'Placement Committee Approved'},
    { label: 'Capital Re-Approved', key: 'Capital Re-Approved'},
    { label: 'LOI Signed', key: 'LOI Signed'},
    { label: 'LOI Expiration', key: 'LOI Expiration'},
    { label: 'Screening Committee', key: 'Screening Committee'},
    { label: 'Model Sent', key: 'Model Sent'},
    { label: 'Capital Committee', key: 'Capital Committee'},
    { label: 'Added To Pipeline', key: 'Added To Pipeline'},
    { label: 'Closed', key: 'Closed'},
    { label: 'Days Old', key: 'Days Old'}
  ];

  ngOnInit() {
    this._formatDates()
    this.rows = this._pipelinesService.splitExpandedRowChunk(this.displayFields, 2)
  }


  public toggleExpand(){
    this.expanded = !this.expanded
  }

  private _formatDates(){
    let projdates = this.detail.project_dates
    let milestones = this.detail.milestones;
    let dates = [...projdates, ...milestones]
    this.dateDetail = dates.reduce((dcc:any, date:any) => {
      let field = date.date_type ? date.date_type : date.milestone
      dcc[field] = {
        is_target: date.date_class ? date.class == 'target' : date.target,
        value: date.date,
        milestoneDates: date?.milestone_dates ?? []
      }
      return dcc
    }, {})

    this.dateDetail = {
      ...this.dateDetail,
      "Model Sent": {value: this.detail.ltmodel_sent, is_target: false},
      "Days Old": {value: this.detail.days_old, is_target: false},
      "Added to Pipeline": { value: this.detail.project_added, is_target: false}
    }
  }
}
